import { IonHeader, IonToolbar, IonButtons, IonButton, IonModal, IonTitle, IonContent } from "@ionic/react";
import React, { useEffect, useState } from "react";
import LocationService from "../LocationService";
import LocationViewer from "./LocationViewer";
import Point from "@arcgis/core/geometry/Point";

interface Props {
    isOpen: boolean;
    onClose: () => void;
    webMapItemId?: string;
    arcgisToken?: string;
}

const ShowCurrentLocationModal: React.FC<Props> = ({ isOpen, onClose, webMapItemId, arcgisToken }) => {
    const [point, setPoint] = useState<Point | null>(null);

    useEffect(() => {
        if (isOpen) {
            LocationService.getCurrentPosition({ maximumAge: 0 }).then((position) => {
                const newPoint = new Point({
                    latitude: position.coords.latitude,
                    longitude: position.coords.longitude,
                });
                setPoint(newPoint);
            });
        } else {
            setPoint(null);
        }
    }, [isOpen]);

    return (
        <IonModal isOpen={isOpen} onDidDismiss={onClose}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Current Location</IonTitle>
                    <IonButtons slot="end">
                        <IonButton onClick={onClose} strong>
                            Close
                        </IonButton>
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent class="outer-content">
                <LocationViewer point={point} webMapItemId={webMapItemId} arcgisToken={arcgisToken} />
            </IonContent>
        </IonModal>
    );
};

export default ShowCurrentLocationModal;
